import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Divider, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import CustomCard from '../CustomCard/CustomCard';
import CustomModal from '../CustomModal/CustomModal';
import CustomPopOver from '../CustomPopOver/CustomPopOver';
import GlobalSearch from '../GlobalSearch';
import Settings from './Settings/Settings';

import { ReactComponent as AdminButton } from 'assets/admin-button.svg';
import { ReactComponent as LogoutIcon } from 'assets/logout-red.svg';
import { ReactComponent as SettingIcon } from 'assets/settings.svg';

import { useInput } from 'customHook/useInput';

import RoutePaths from 'routes/RoutePaths';

import { AuthService } from 'service/auth.service';
import { HuddleService } from 'service/huddle.service';
import { SFService } from 'service/SF.service';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { switchAdmin } from 'store/slices/dashboardSlice';
import { setOpenAddLeadDrawer } from 'store/slices/leadsSlice';

import zeplinColor from 'theme/Color';
import styles from './Header.module.css';

import { Utilities } from 'utilities/utilities';
import validator from 'validator';
import axios from 'axios';

const Header = () => {
  const dispatch = useAppDispatch();
  const userName = sessionStorage.getItem('user-name') || '';
  const userRole = sessionStorage.getItem('user-role') || '';
  const userEmail = sessionStorage.getItem('current-user') || '';
  const location = useLocation();
  const linkInputRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const adminConsole = useAppSelector((state) => state.dashboard.adminConsole);
  const {
    user: { role, isAdmin, isSuperAdmin },
  } = useAppSelector((state) => state.auth);
  const locationName = location.pathname.split('/').at(-1);
  const newRouteMatch = location.pathname.match(/^\/([^/]+)\/new$/);
  const editRouteMatch = location.pathname.match(/^\/([^/]+)\/[^/]+\/edit$/);

  const headerLabel =
    location.pathname === '/leads/new-lead/social-insights'
      ? 'Social Insights'
      : location.pathname === '/dashboard/admin' && adminConsole
        ? 'Admin Console'
        : newRouteMatch?.length
          ? `New ${Utilities.toCamelCase(newRouteMatch[1])}`
          : editRouteMatch
            ? `Edit ${Utilities.toCamelCase(editRouteMatch[1])}`
            : Utilities.toCamelCase(locationName ? locationName : '');
  const details = location.pathname?.split('/');

  const [selectedSettings, setSelectedSettings] = useState('Profile');
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);

  const [openSettingsModal, setOpenSettingsModal] = React.useState(false);
  const [linkField, setLinkField] = React.useState(false);
  const [profileLoader, setProfileLoader] = React.useState(false);
  const [linkLoader, setLinkLoader] = React.useState(false);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const [anchorElLink, setAnchorElLink] = React.useState<HTMLDivElement | null>(null);
  const customLinkIdx = useRef<number | null>(null);

  const handleClickLink = (
    event: React.MouseEvent<HTMLDivElement>,
    type:
      | 'customLink'
      | 'facebook_profile_url'
      | 'instagram_profile_url'
      | 'twitter_profile_url'
      | 'linkedin_profile_url',
    edit = false,
    element = 0,
  ) => {
    if (linkField) {
      setLinkField((prev) => !prev);
      setLink('');
      setLinkPost({ customLink: '' });
    } else if (!linkField && (event.target as HTMLDivElement).getAttribute('alt') === 'option') {
      setLinkField(true);
      handleLinkField(type, edit, element);
    }
    customLinkIdx.current = type === 'customLink' ? element : null;

    setTimeout(() => {
      if (linkInputRef?.current) {
        linkInputRef.current.scrollTop = linkInputRef.current.scrollHeight;
      }
    }, 0);
  };

  const handleDeleteCustomLink = async () => {
    try {
      setAnchorElLink(null);
      setLinkLoader(true);
      if (customLinkIdx?.current !== null) {
        await HuddleService.saveProfile(userEmail, {
          customLink: profile?.customLink.filter((val, ind) => ind !== customLinkIdx?.current),
        });
      }
      customLinkIdx.current = null;
      setLink('');
      setLinkPost({ customLink: '' });
      setAlert('Custom link removed successfully');
    } catch (err) {
      setAlert('Something went wrong');
    } finally {
      setLinkLoader(false);
    }
  };
  const openLink = Boolean(anchorElLink);
  const idLink = openLink ? 'simple-popover' : undefined;

  const [alert, setAlert] = React.useState('');
  const token = sessionStorage.getItem('user-token') || '';
  const isMSLogin = sessionStorage.getItem('ms_login') || '';
  let accessToken: any = {};
  if (token) {
    accessToken = JSON.parse(token);
  }
  const [openModal, setOpenModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [profile, setProfile] = React.useState<{
    Address: {
      city: string;
      country: string;
      geocodeAccuracy: string;
      latitude: string;
      longitude: string;
      postalCode: string;
      state: string;
      street: string;
    };
    Email: string;
    MobilePhone: string;
    Name: string;
    Phone: string;
    Role: string;
    SF_Profile_URL: string;
    facebook_profile_url: string;
    instagram_profile_url: string;
    profile_image_url: string;
    twitter_profile_url: string;
    linkedin_profile_url: string;
    customLink: [string];
  }>({
    Address: {
      city: '',
      country: '',
      geocodeAccuracy: '',
      latitude: '',
      longitude: '',
      postalCode: '',
      state: '',
      street: '',
    },
    Email: '',
    MobilePhone: '',
    Name: '',
    Phone: '',
    Role: '',
    SF_Profile_URL: '',
    facebook_profile_url: '',
    instagram_profile_url: '',
    profile_image_url: '',
    twitter_profile_url: '',
    linkedin_profile_url: '',
    customLink: [''],
  });

  const handleOpen = () => {
    setOpenModal(true);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const signOut = async () => {
    setLoading(true);
    try {
      const res = await AuthService.logout({
        accessToken: accessToken?.AccessToken,
        isMSLogin: isMSLogin ? true : false,
      });

      if (res?.microsoftLogoutUrl) {
        sessionStorage.clear();

        window.location.href = res?.microsoftLogoutUrl;
      } else {
        sessionStorage.removeItem('loginExpiry');
        sessionStorage.removeItem('redirect_path');
        sessionStorage.removeItem('refreshToken');
        sessionStorage.removeItem('user-name');
        sessionStorage.removeItem('user-token');

        sessionStorage.removeItem('currentTab');
        navigate(RoutePaths.Root);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getProfileDetails = async () => {
    try {
      setLoading(true);
      const res = await SFService.getProfileDetails(userEmail);
      setProfile(res);
    } catch (err: any) {
      setAlert('Something went wrong!');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenSettings = () => {
    setAnchorEl(null);
    setOpenSettingsModal(true);
  };

  const handleCloseSettings = () => {
    setOpenSettingsModal(false);
    setLinkField(false);
    clearLink();
  };

  useEffect(() => {
    if (!profileLoader || !linkLoader) {
      getProfileDetails();
    }
  }, [profileLoader, linkLoader]);

  const openInput = () => {
    window.document.getElementById('attachment')?.click();
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setProfileLoader(true);
    try {
      if (event.target.files) {
        const res = await SFService.getPresigned(
          userEmail,
          event.target.files[0]?.type,
          event.target.files[0]?.name,
        );
        await axios?.post(
          res.url,
          { ...(res?.fields ?? res?.fileds ?? {}), file: event.target.files[0] },
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          },
        );
        await SFService.updateProfile(userEmail, { profile_image_url: res.fileUrl });
      }
      setAlert('Profile changed successfully');
    } catch (err: any) {
      setAlert('Something went wrong!');
    } finally {
      setProfileLoader(false);
    }
  };

  const handleRemoveDp = async () => {
    try {
      setProfileLoader(true);
      setAlert('User profile successfully removed.');
    } catch (err) {
      setAlert('Something went wrong.');
    } finally {
      setProfileLoader(false);
    }
  };

  const [linkPost, setLinkPost] = useState<
    | { customLink: string }
    | { facebook_profile_url: string }
    | {
        instagram_profile_url: string;
      }
    | { twitter_profile_url: string }
    | { linkedin_profile_url: string }
  >({ customLink: '' });

  const {
    handleChange: handleLinkChange,
    handleBlur: handleLinkBlur,
    clearInput: clearLink,
    value: link,
    invalid: invalidLink,
    didChange: didLinkChange,
    setValue: setLink,
  } = useInput(
    linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost]
      ? linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost]
      : '',
    validator?.isURL,
  );

  const handleLinkField = (
    type:
      | 'customLink'
      | 'facebook_profile_url'
      | 'instagram_profile_url'
      | 'twitter_profile_url'
      | 'linkedin_profile_url',
    edit = false,
    element = 0,
  ) => {
    if (type === 'customLink') {
      if (edit) {
        setLinkPost({ customLink: profile?.customLink[element] });
        setLink(profile?.customLink[element]);
      } else {
        setLinkPost({ customLink: '' });
      }
    } else {
      setLink(profile[type as keyof typeof profile] as string);
      setLinkPost({
        [type]: profile[type as keyof typeof profile] ? profile[type as keyof typeof profile] : '',
      } as
        | { customLink: string }
        | { facebook_profile_url: string }
        | { instagram_profile_url: string }
        | { twitter_profile_url: string }
        | { linkedin_profile_url: string });
    }
  };

  useEffect(() => {
    setLinkPost(
      (prev) =>
        ({ [Object.keys(prev)[0]]: link }) as
          | { customLink: string }
          | { facebook_profile_url: string }
          | { instagram_profile_url: string }
          | { twitter_profile_url: string }
          | { linkedin_profile_url: string },
    );
  }, [link]);

  const handleSave = async () => {
    try {
      setLinkLoader(true);
      if (Object.keys(linkPost)[0] === 'customLink') {
        await HuddleService.saveProfile(userEmail, {
          customLink:
            Array.isArray(profile?.customLink) &&
            customLinkIdx?.current === null &&
            profile?.customLink?.length
              ? [...profile?.customLink, Object.values(linkPost)[0]]
              : Array.isArray(profile?.customLink) && profile?.customLink?.length
                ? [
                    ...profile?.customLink?.map((val, ind) =>
                      ind === customLinkIdx?.current ? Object.values(linkPost)[0] : val ? val : '',
                    ),
                  ]
                : Array.isArray(profile?.customLink) && !profile?.customLink?.length
                  ? [Object.values(linkPost)[0]]
                  : [profile?.customLink, Object.values(linkPost)[0]],
        });
        customLinkIdx.current = null;
        setLinkField(false);
        setAlert('Link successfully saved');
        setLinkPost({ customLink: '' });
        setLink('');
      } else {
        await HuddleService.saveProfile(userEmail, {
          ...linkPost,
        });
        setLinkField(false);
        setAlert('Link successfully saved');
      }
    } catch (err: any) {
      setAlert('Something went wrong');
    } finally {
      clearLink();
      setLinkLoader(false);
    }
  };

  const linkValue = linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost] as string;
  const isAdminRolePermission = details.includes('admin') && details.length > 3;

  const isDetailPage = details.length > 2 && !details.includes('admin');

  const isSocialInsights = location.pathname === '/leads/new-lead/social-insights';

  const sectionLabel =
    details[1] === 'asana'
      ? 'Projects'
      : `${details[1]?.charAt(0).toUpperCase()}${details[1]?.slice(1)}`;

  let detailLabel = '';
  if (newRouteMatch) {
    const matchType = newRouteMatch[1];
    if (matchType === 'deals') detailLabel = 'New Deal';
    if (matchType === 'clients') detailLabel = 'New Client';
    else detailLabel = `New ${Utilities.toCamelCase(matchType)}`;
  } else if (editRouteMatch) {
    const matchType = editRouteMatch[1];
    detailLabel = matchType === 'deals' ? 'Edit Deal' : `New ${Utilities.toCamelCase(matchType)}`;
  } else {
    const detailType = details[1];

    switch (detailType) {
      case 'asana':
        detailLabel = 'Project Details';
        break;
      case 'deals':
        detailLabel = 'Deal Details';
        break;
      case 'team':
        detailLabel = 'Member Details';
        break;
      case 'client':
        detailLabel = 'Client Details';
        break;
      case 'businesses':
        detailLabel = 'Business Details';
        break;
      default:
        if (detailType) {
          const formatted = detailType;
          const capitalized = formatted.charAt(0).toUpperCase() + formatted.slice(1);
          detailLabel = `${capitalized} Details`;
        } else {
          detailLabel = 'Details';
        }
    }
  }

  const handleGoBack = () => {
    if (isSocialInsights) {
      dispatch(setOpenAddLeadDrawer(true));
      navigate('/leads');
    } else {
      sessionStorage.removeItem('currentTab');
      navigate(-1);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: { xs: '12px 16px', xl: '16px 24px' },
          alignItems: 'center',
        }}
      >
        {isSocialInsights || isDetailPage ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'flex-start' }}>
            <Box sx={{ display: 'flex', gap: '1px' }}>
              <Typography variant='label2' color={zeplinColor.Neutral8}>
                {sectionLabel}/
              </Typography>
              <Typography variant='label2'>
                {isSocialInsights ? 'Social Insights' : detailLabel}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '-8px',
                gap: '10px',
              }}
            >
              <img
                src={`/assets/back-icon.svg`}
                width='24px'
                height='24px'
                onClick={handleGoBack}
                style={{ cursor: 'pointer' }}
                alt='back-icon'
              />
              <Typography variant='responsiveHeading1'>
                {isSocialInsights ? 'Social Insights' : detailLabel}
              </Typography>
            </Box>
          </Box>
        ) : isAdminRolePermission ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'flex-start' }}>
            <Box sx={{ display: 'flex', gap: '1px' }}>
              <Typography variant='label2' color={zeplinColor.Neutral8}>
                Admin Console/
              </Typography>
              <Typography variant='label2'>Role Permission</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '-8px',
                gap: '10px',
              }}
            >
              <img
                src={`/assets/back-icon.svg`}
                width='24px'
                height='24px'
                onClick={handleGoBack}
                style={{ cursor: 'pointer' }}
                alt='back-icon'
              />
              <Typography variant='responsiveHeading1'>Role Permission</Typography>
            </Box>
          </Box>
        ) : (
          <Typography variant='responsiveHeading1' sx={{ flex: 1, alignItems: 'flex-start' }}>
            {details[1] === 'Asana' ? 'Project' : headerLabel}
          </Typography>
        )}

        <GlobalSearch />

        <Box
          sx={{
            display: 'flex',
            gap: '16px',
            flex: 1,
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          {(isAdmin || isSuperAdmin) && (
            <Box
              sx={{
                width: '48px',
                height: '48px',
                borderRadius: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: adminConsole ? zeplinColor.Neutral3 : 'transparent',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: adminConsole ? zeplinColor.Neutral5 : zeplinColor.Neutral3,
                },
              }}
            >
              <AdminButton
                width='24px'
                height='24px'
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  adminConsole ? navigate(RoutePaths.Home) : navigate(RoutePaths.Home + '/admin');
                  dispatch(switchAdmin());
                }}
              />
            </Box>
          )}

          <Box
            sx={{
              height: 48,
              borderRadius: 50,
              backgroundColor: zeplinColor.Neutral3,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '16px',
              padding: '6px',
              cursor: 'pointer',
            }}
            onClick={handleClick}
          >
            <Box
              sx={{
                height: 48,
                borderRadius: 50,
                backgroundColor: zeplinColor.Neutral3,
                display: 'flex',

                alignItems: 'center',
                gap: '8px',
                padding: '6px',
              }}
            >
              <Box
                sx={{
                  borderRadius: '100px',
                  padding: '10px',
                  width: { xs: '30px', xl: '36px' },
                  height: { xs: '30px', xl: '36px' },
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: profile?.profile_image_url ? 'transparent' : zeplinColor.Brand1,
                }}
              >
                {profile?.profile_image_url ? (
                  <img
                    className={styles['profile-img']}
                    src={profile?.profile_image_url}
                    alt='profile-img'
                    style={{ borderRadius: '100px', objectFit: 'fill' }}
                  />
                ) : (
                  <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                    {userName
                      ?.split(' ')
                      .map((value: any, index: number) =>
                        userName && (index === 0 || index === userName?.split(' ').length - 1)
                          ? value[0]
                          : '',
                      )}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                  {userName}
                </Typography>
                <Typography variant='responsiveCaption' color={zeplinColor.Neutral8}>
                  {role}
                </Typography>
              </Box>
            </Box>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </Box>
        </Box>

        <CustomPopOver
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          id={id}
          sx={{
            borderRadius: '14px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
            marginTop: '8px',
            marginRight: '0rem',
            zIndex: 999,
          }}
        >
          <Box
            sx={{
              paddingTop: '24px',
              width: '210px',
              height: '192px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                display: 'flex',

                alignItems: 'center',
                gap: '8px',
                padding: '0px 16px',
                cursor: 'pointer',
              }}
            >
              <Box
                sx={{
                  borderRadius: '100px',
                  padding: '10px',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: profile?.profile_image_url ? 'transparent' : zeplinColor.Brand1,
                }}
              >
                {profile?.profile_image_url ? (
                  <img
                    width={'36px'}
                    height={'36px'}
                    src={profile?.profile_image_url}
                    alt='profile-img'
                    style={{ borderRadius: '100px', objectFit: 'fill' }}
                  />
                ) : (
                  <Typography variant='label1' color={zeplinColor.Neutral1}>
                    {userName
                      ?.split(' ')
                      .map((value: any, index: number) =>
                        userName && (index === 0 || index === userName?.split(' ').length - 1)
                          ? value[0]
                          : '',
                      )}
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Typography variant='body3' color={zeplinColor.BasicBlack}>
                  {userName}
                </Typography>
                <Typography variant='caption' color={zeplinColor.Neutral8}>
                  {role}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                padding: '8px 0px',

                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              {' '}
              <Box
                sx={{
                  display: 'flex',
                  cursor: 'pointer',
                  gap: '16px',
                  padding: '16px',
                }}
                onClick={handleOpenSettings}
              >
                <SettingIcon width='18px' height='18px' />
                <Typography variant='body3' color={zeplinColor.BasicBlack}>
                  Settings
                </Typography>
              </Box>
              <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
              <Box
                sx={{
                  display: 'flex',
                  cursor: 'pointer',
                  gap: '16px',
                  padding: '16px',
                }}
                onClick={handleOpen}
              >
                <LogoutIcon width='18px' height='18px' />
                <Typography variant='body3' color={zeplinColor.Error}>
                  Logout
                </Typography>
              </Box>
            </Box>
          </Box>
        </CustomPopOver>
        <CustomModal handleClose={handleClose} open={openModal}>
          <Box
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
          >
            <CustomCard
              styles={{
                borderRadius: '14px',
                padding: '24px',
                backgroundColor: zeplinColor.Neutral1,

                width: '312px',
                height: '183px',
                boxShadow: 'rgba(0, 0, 0, 0.15)',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  gap: '32px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                  }}
                >
                  <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                    Log Out?
                  </Typography>
                  <Typography variant='body3' color={zeplinColor.BasicBlack}>
                    Are you sure you want to log out?
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    gap: '16px',
                  }}
                >
                  <Box onClick={handleClose}>
                    <CustomCard
                      styles={{
                        borderRadius: '14px',
                        padding: '14px 32px',
                        backgroundColor: zeplinColor.Neutral1,
                        border: `1px solid ${zeplinColor.BasicBlack}`,
                        cursor: 'pointer',
                      }}
                      aria-label='button'
                      aria-disabled={loading}
                    >
                      <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                        Cancel
                      </Typography>
                    </CustomCard>
                  </Box>
                  <Box onClick={signOut} sx={{ flex: 1 }}>
                    <CustomCard
                      styles={{
                        borderRadius: '14px',
                        padding: '14px 16px',
                        backgroundColor: zeplinColor.BasicBlack,
                        cursor: 'pointer',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minWidth: '120px',
                      }}
                      aria-label='button'
                      aria-disabled={loading}
                    >
                      <Typography
                        variant='buttonMedium'
                        color={zeplinColor.Neutral1}
                        sx={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          textAlign: 'center',
                          width: '100%',
                        }}
                      >
                        {loading ? 'Logging out' : 'Log Out'}
                      </Typography>
                    </CustomCard>
                  </Box>
                </Box>
              </Box>
            </CustomCard>
          </Box>
        </CustomModal>
        <Settings
          handleCloseSettings={handleCloseSettings}
          openSettingsModal={openSettingsModal}
          setLinkField={setLinkField}
          clearLink={clearLink}
          setOpenSettingsModal={setOpenSettingsModal}
          setSelectedSettings={setSelectedSettings}
          selectedSettings={selectedSettings}
          linkInputRef={linkInputRef}
          profile={profile}
          profileLoader={profileLoader}
          handleFileChange={handleFileChange}
          openInput={openInput}
          loading={loading}
          handleRemoveDp={handleRemoveDp}
          handleClickLink={handleClickLink}
          linkField={linkField}
          handleLinkBlur={handleLinkBlur}
          handleLinkChange={handleLinkChange}
          link={link}
          invalidLink={invalidLink}
          didLinkChange={didLinkChange}
          linkLoader={linkLoader}
          linkPost={linkPost}
          handleSave={handleSave}
          customLinkIdx={customLinkIdx}
          linkValue={linkValue}
          setLink={setLink}
          setLinkPost={setLinkPost}
          setAnchorElLink={setAnchorElLink}
          anchorElLink={anchorElLink}
          idLink={idLink}
          handleDeleteCustomLink={handleDeleteCustomLink}
          userEmail={userEmail}
          alert={alert}
          setAlert={setAlert}
          handleLinkField={handleLinkField}
        />
      </Box>
      <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
    </>
  );
};

export default Header;
